<br />
<div class="table-container" *ngIf="fileList.length > 0">
  <table mat-table [dataSource]="fileList" class="col-12">
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Nome</th>
      <td mat-cell *matCellDef="let element">
        {{ element.name }}
      </td>
    </ng-container>

    <ng-container matColumnDef="createDate">
      <th mat-header-cell *matHeaderCellDef>Data de Criação</th>
      <td mat-cell *matCellDef="let element">
        {{ element.creationDate | date : "dd/MM/yyyy hh:mm:ss" }}
      </td>
    </ng-container>

    <ng-container matColumnDef="createUser">
      <th mat-header-cell *matHeaderCellDef>Responsável</th>
      <td mat-cell *matCellDef="let element">
        {{ element.creationUser }}
      </td>
    </ng-container>

    <ng-container matColumnDef="actions" sticky>
      <th mat-header-cell *matHeaderCellDef class="actions">Ações</th>
      <td mat-cell *matCellDef="let element; let i = index" class="actions">
        <div>
          <a *ngIf="isValidFile(element.name)" (click)="openPdf(element.name)">
            <fa-icon [icon]="faEye" style="color: rgb(22, 175, 43)"></fa-icon>
          </a>
          <a (click)="download(element.name)">
            <fa-icon [icon]="faDownload" style="color: blue"></fa-icon>
          </a>
          <th mat-header-cell *matHeaderCellDef></th>
          <a
            *ngIf="
              ((canUploadTransfer() && canEdit) || canApproveUpload()) &&
              canDeleteFile(element.id)
            "
            (click)="delete(element.id)"
          >
            <fa-icon [icon]="faTrash" style="color: red"></fa-icon>
          </a>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="ColumnsFile; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: ColumnsFile"></tr>
  </table>
</div>
